__turbopack_context__.v({
  "burger": "-6_eqa_burger",
  "closeButton": "-6_eqa_closeButton",
  "closeHeader": "-6_eqa_closeHeader",
  "drawerBody": "-6_eqa_drawerBody",
  "drawerCloseButton": "-6_eqa_drawerCloseButton",
  "drawerContent": "-6_eqa_drawerContent",
  "listButton": "-6_eqa_listButton",
  "logoutButton": "-6_eqa_logoutButton",
  "menu": "-6_eqa_menu",
  "menuRoot": "-6_eqa_menuRoot",
});
